module.exports = __webpack_public_path__ + "static/media/WhatsApp_white.ab680b79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WhatsApp_white.svg
// module id = 76
// module chunks = 0